import { useParams } from "react-router-dom";
import ClientMessagesInterface from "../components/UI/Messages/client-messages-interfaces"

const Chat = () => {
    const { conversationId } = useParams<{ conversationId?: string }>();

    return (
        <main className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Mis Mensajes</h1>
          <p className="text-gray-600">Comunícate con tus anfitriones</p>
        </div>
        <ClientMessagesInterface conversationId={conversationId} />
      </main>
    )
}

export default Chat